import { CATEGORY_PATH_SEPARATOR } from './relatedCategorySelection'
import normalizeDateInput from '../../utils/utm/normalizeDateInput'

const formatCampaignDateForInput = (value) => {
  const isoDate = normalizeDateInput(value)

  if (!isoDate) {
    return ''
  }

  const [year, month, day] = isoDate.split('-')

  return `${day}.${month}.${year}`
}

const buildRelatedCategoryFromRecord = (record = {}) => {
  const hasCategory = Boolean(
    record.relatedGlobalCategoryId ||
      record.relatedOutletGlobalCategoryId ||
      record.relatedCategoryPathLabel
  )

  if (!hasCategory) {
    return null
  }

  const pathFromRecord = Array.isArray(record.relatedGlobalCategoryPath)
    ? record.relatedGlobalCategoryPath.filter(Boolean)
    : []
  const pathFromLabel = record.relatedCategoryPathLabel
    ? record.relatedCategoryPathLabel.split(CATEGORY_PATH_SEPARATOR)
    : []

  return {
    related_category_source: record.relatedCategorySource,
    related_category_level: record.relatedCategoryLevel,
    related_global_category_id: record.relatedGlobalCategoryId,
    related_global_category_name: record.relatedGlobalCategoryName,
    related_outlet_global_category_id: record.relatedOutletGlobalCategoryId,
    related_category_path_label: record.relatedCategoryPathLabel,
    related_global_category_path: pathFromRecord.length > 0 ? pathFromRecord : pathFromLabel,
    related_product_filter: record.relatedProductFilter,
  }
}

export const mapCampaignLinkToBuilderState = (record = {}) => {
  const relatedBrands = (record.relatedBrandIds || []).map((id, index) => ({
    id,
    name: record.relatedBrandNames?.[index] || id,
  }))

  const relatedCategory = buildRelatedCategoryFromRecord(record)

  const relatedProduct = record.relatedProductId
    ? {
        id: record.relatedProductId,
        source: record.relatedProductSource,
        name: record.relatedProductName,
        barcode: record.relatedProductBarcode,
        label: record.relatedProductLabel || record.relatedProductName,
      }
    : null

  const relatedPromo = record.relatedPromoId
    ? {
        id: record.relatedPromoId,
        title: record.relatedPromoTitle,
        startDate: record.relatedPromoStartDate,
        endDate: record.relatedPromoEndDate,
        source: record.relatedPromoSource || 'cashbox',
        label: record.relatedPromoTitle,
      }
    : null

  return {
    formData: {
      title: record.title || '',
      destinationUrl: record.destinationUrl || '',
      isActive: record.isActive !== false,
      owner: record.owner || record.responsible || '',
      channel: record.channel || '',
      format: record.format || '',
      direction: record.direction || '',
      campaign_date: formatCampaignDateForInput(record.campaignDate),
    },
    relatedBrands,
    relatedCategory,
    relatedProduct,
    relatedPromo,
    savedShortLink: record.shortUrl
      ? {
          short_slug: record.shortSlug,
          short_path: record.shortPath,
          short_url: record.shortUrl,
        }
      : null,
  }
}

export default mapCampaignLinkToBuilderState
